import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Inject, OnInit, SecurityContext, TemplateRef, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { distinctUntilChanged, map, pairwise } from "rxjs/operators";
import { AuthService } from "../../../../auth/auth.service";
import { BASE_API_URL } from "../../../../core/environment.tokens";
import { MessagingService } from "../../../../core/messaging/messaging.service";
import { SeverityType } from "../../../../core/messaging/severity-type.enum";
import { ClientOrgModel } from "../../../../core/user/client-org-model";
import { DynamicControl } from "../../../../dynamic-forms/dynamic-control.model";
import { FormService } from "../../../../dynamic-forms/form.service";
import { CheckboxGroup } from "../../../../dynamic-forms/inputs/checkbox-group/checkbox-group.model";
import { Dropdown } from "../../../../dynamic-forms/inputs/dropdown/dropdown.model";
import { Radiobutton } from "../../../../dynamic-forms/inputs/radiobutton/radiobutton.model";
import { SelectableInput } from "../../../../dynamic-forms/inputs/selectable-input.model";
import { Switch } from "../../../../dynamic-forms/inputs/switch/switch.model";
import { TextBoxWithButton } from "../../../../dynamic-forms/inputs/textbox-with-button/textboxwithbutton.model";
import { Textbox } from "../../../../dynamic-forms/inputs/textbox/textbox.model";
import { CustomPendCheckboxGroup } from "../../../../shared/custom-pend-checkbox-group/custom-pend-checkbox-group.model";
import { BulkAction } from "../../../../shared/grid/bulk-actions/bulk-action.model";
import { GridColumnDefinition } from "../../../../shared/grid/models/grid-column-definition.model";
import { GridConfiguration } from "../../../../shared/grid/models/grid-configuration.model";
import { GridRequest } from "../../../../shared/grid/models/grid-request.model";
import { LogoDataSharingService } from "../../../../shared/logo/logo-data-sharing.service";
import { LogoService } from "../../../../shared/logo/logo.service";
import { ServiceOrgLogoResponseModel } from "../../../../shared/logo/service-org-logo-response.model";
import { UserMessages } from "../../../../shared/messages/user-messages";
import { CreatePendService } from "../../../../shared/pend/create-pend.service";
import { TagActionType } from "../../../../shared/tags/model/tag-action-type.enum";
import { ArrayHelper } from "../../../../utilities/contracts/array-helper";
import { NumberHelper } from "../../../../utilities/contracts/number-helper";
import { StringHelper } from "../../../../utilities/contracts/string-helper";
import { RegExHelper } from "../../../../utilities/reg-Ex-Helper";
import { DocumentUploadRequestRetrievalType } from "../../../api/document-upload/document-upload-retrievaltype.enum";
import { AUTH0ENABLED, DOCUMENT_ROUTING, ENABLED_SSO, SSO_CONFIGURATION } from "../../member/chase-detail/chase-detail-chart/attributes";
import { ActionItem } from "../../retrieval/retrieval-page/retreival-page-action-item";
import { OrganizationPendCode } from "./model/organization-pend-code.model";
import { PendCategories } from "./model/pend-categories.enum";
import { PendCodeCount } from "./model/Pend-Code-Count.model";
import { ServiceOrgConfigModel } from "./model/service-org-config.model";
import { SsoConfiguration } from "./model/sso-configuration.model";
import { Tags } from "./model/Tags.model";
import { TotalTagCount } from "./model/total-tag-count.model";
import { ServiceOrgConfigurationService } from "./service-org-config.service";

@Component({
  selector: "app-service-org-config",
  templateUrl: "./service-org-config.component.html",
  styleUrls: ["./service-org-config.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceOrgConfigComponent implements OnInit {
  contactData: any = null;
  serviceOrgTitle: string;
  organizationAttributeData = null;
  providerEmailForm: FormGroup;
  serviceOrgForm: FormGroup;
  contactDataForm: FormGroup;
  organizationAttributeDataForm: FormGroup;
  readonly contactDataInputs: DynamicControl[] = [];
  readonly serviceOrgInputs: DynamicControl[] = [];
  maxChaseCount: Textbox;
  dailyMaxChaseCount: Textbox;
  selectedTab = "serviceOrganization";
  groupGridConfiguration = new GridConfiguration();
  groupGridRequest: GridRequest;
  groupActionItems: ActionItem[] = [];
  groupModalHeader: string;
  groupId: number;
  groupName: string;
  groupAction: string;
  isGroupModalVisible = false;
  isPendModalVisible = false;
  isEditPendCode = false;
  pendCodeTypeId: number;
  hasCustomPendCodes = false;
  // temporary until release/r2023-11

  groupForm: FormGroup;
  groupNameInputs: any[];
  gridRefresh = new EventEmitter<null>(true);
  reviewPagesOfChartInput: Radiobutton;
  persistAIDAssignmentInput: Radiobutton;
  multiFactorAuthenticationInput: Radiobutton;
  includeChartSiteIdInput: Radiobutton;

  isShowVendorDetail: boolean;
  providerAgingToggleInput: Switch;
  automatedOutreachToggleInput: Switch;
  emailSubjectInput: Textbox;
  daysBeforeOverdueInput: Textbox;
  daysBeforeNextCallInput: Textbox;
  providerEmailDetails = [];
  providerEmailData: any = null;
  actions: BulkAction[];
  dashboardTagCount: TotalTagCount[] = [];
  TagGridConfiguration = new GridConfiguration();
  @ViewChild("tagColumn", { static: true }) tagColumn: TemplateRef<any>;
  tagGridRequest: Tags[] = [];
  entityName: string;
  isManageTagModalVisible: boolean;
  isEditTags: boolean;
  isCreateTag: boolean;
  editTagObj: any;
  isDeleteTag: boolean;
  tagAction: TagActionType;
  headerSet: string;
  selectedTag: string;
  tagTypeName: string;
  setSelectedTagType: string;
  searchPhraseForm: FormGroup;
  searchPhraseInput = new Textbox({ key: "SearchPhrase" });
  isShowSearchIcon: boolean;
  hasSearchResult: boolean;
  tagTypeId: number;
  isReplaceTag: boolean;
  createNewHeader: number;
  rows: number;
  totalRecords: number;
  startRecord = 0;
  endRecord = 25;
  recordPerPage = 25;
  tagPageNumber = 0;
  requestRejectedInput: CheckboxGroup;
  digitPendCodesInput: CheckboxGroup;
  codesDataLoadsInput: CheckboxGroup;
  customCreatedCodesInput: CustomPendCheckboxGroup;
  medicalRecordsInput: CheckboxGroup;
  providerIndicatesCannotRetrieveInput: CheckboxGroup;
  iVARiskSpecificInput: CheckboxGroup;
  memberCentricInput: CheckboxGroup;
  clinicalCodesInput: CheckboxGroup;
  generalCodesInput: CheckboxGroup;
  pendCodeManagerForm: FormGroup;
  isClinical: boolean;
  isIVARisk: boolean;
  isMemberCentric: boolean;
  isRefusalRequestRejected: boolean;
  is4DigitPendCodes: boolean;
  isCodesDataLoads: boolean;
  isCustomPendCodes: boolean;
  isFailureMedicalRecords: boolean;
  isProviderIndicates: boolean;
  isGeneralCodes: boolean;
  isAllPendCodes: boolean;
  dashboardPendCodeCount: PendCodeCount[] = [];
  pendCodeCategories: number;
  organizationPendCode: OrganizationPendCode;
  pendCodeList: any[];
  pendType: null;
  inActivePendCodeList: string;
  clinicalPendCodeMessage = "These pends codes cannot be hidden as they are required for Medical Record Review";
  fourDigitPendCodeMessage = "4-Digit Pend codes are automatically applied and will always appear within the Reveleer application";
  formGroup: FormGroup;
  formModels: DynamicControl[];
  checkedCustomPendCode: SelectableInput[] = [];
  serviceOrgLogo: Textbox;
  formData: FormData = new FormData();
  selectedFile: any[] = [];
  uploadedImageUrl: SafeResourceUrl;
  logo: SafeResourceUrl;
  uploadedFileName: string;
  @ViewChild("fileUpload") fileUpload: any;
  categoryId = 0;
  isProviderAgingSampleModelVisible = false;
  providerAgingSampleImageUrl: SafeResourceUrl;
  lockedPendCodesList: string[];
  documentRoutingBulkUploadToggleInput: Switch;
  documentRoutingFaxToggleInput: Switch;
  documentRoutingFTPToggleInput: Switch;
  documentRoutingMailToggleInput: Switch;
  documentRoutingProviderGatewayInput: Switch;
  documentRoutingIntakeToggleInput: Switch;
  documentRoutingForm: FormGroup;
  showDocumentRoutingPopup = false;
  documentRoutingDescription: string;
  selectedDocumentRouting: string;
  isSelectedDocumentRoutingChecked = false;
  showPagination = true;
  defaultDaysBeforeNextCall = "7";

  ssoToggleInput: Switch;
  ssoOptionInput: Radiobutton;
  ssoInputsForm: FormGroup;
  isLegacySSOSelected = false;
  isFederated = false;

  indentityProviderInput: Dropdown;
  applicationIdInput: Textbox;
  directoryIdInput: Textbox;
  ssoConfigForm: FormGroup;
  ssoDomainForm: FormGroup;

  isSsoEnabled = false;
  isAuth0Enabled = false;
  isOrganizationEnabledToDisplaySingleSignOnSettings = false;
  CallerIdVVerificationCode: any;
  callerIdVerificationStatus = false;
  customCallerIdDescription: string = UserMessages.customCallerIdDescription;
  showCallerIdPopup: boolean;
  callerIdNumber: any;
  presignedUrlForLogo: string;
  logoFile: File;
  normalizedFileName: string;
  callerIdValidationControl: TextBoxWithButton;
  constructor(
    private changeDetector: ChangeDetectorRef,
    private readonly formService: FormService,
    private service: ServiceOrgConfigurationService,
    private messagingService: MessagingService,
    private formBuild: FormBuilder,
    private readonly createPendService: CreatePendService,
    private readonly domSanitizer: DomSanitizer,
    private readonly logoService: LogoService,
    private logoDataSharingService: LogoDataSharingService,
    private authService: AuthService,
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private fb: FormBuilder
  ) {
    this.providerAgingToggleInput = new Switch({
      key: "providerAgingToggle",
      followingOnLabel: "WEEKLY STATEMENTS",
    });

    this.automatedOutreachToggleInput = new Switch({
      key: "automatedOutreachToggle",
      followingOnLabel: "AUTOMATED OUTREACH",
    });

    this.daysBeforeOverdueInput = new Textbox({
      key: "daysBeforeOverdue",
      validators: [Validators.pattern(RegExHelper.number), Validators.maxLength(2), Validators.pattern(RegExHelper.number1To100)],
      errorMessages: {
        maxlength: "Days before overdue can not be more than 2 characters.",
        pattern: "Value must be numbers between 1-100 only",
      },
      label: "Days Before Overdue (Commitment Date)",
      tooltip: "Set the number of days after the request has been sent that it is considered overdue and additional follow up is needed. This sets the commitment date on the chases included in the request. (default if nothing entered is 21 days)",
    });

    this.daysBeforeNextCallInput = new Textbox({
      key: "daysBeforeNextCall",
      validators: [Validators.pattern(RegExHelper.number), Validators.maxLength(2), Validators.pattern(RegExHelper.number1To100)],
      errorMessages: {
        maxlength: "Days before next call can not be more than 2 characters.",
        pattern: "Value must be numbers between 1-100 only",
      },
      label: "Days Before Next Call",
      tooltip: "Set the number of days after a request has been sent to populate the next call date for an address. This can be used prioritizing follow up on requests before they become overdue.(The default if nothing entered is 7 days.",
    });

    this.emailSubjectInput = new Textbox({
      key: "emailSubject",
      label: "Email Subject",
      placeholder: "Email Subject",
    });

    this.serviceOrgInputs = [
      new Textbox({
        key: "name",
        label: "Service Org Name",
        placeholder: "Service Org Name",
        validators: [Validators.required],
        errorMessages: {
          required: "This field is required.",
        },
      }),
      new Textbox({
        key: "contactName",
        label: "Contact Name",
        placeholder: "Contact Name",
      }),
    ];
    this.callerIdValidationControl = new TextBoxWithButton({
      key: "customerOutboundCallerIdNumber",  // New key for custom outbound number
      label: "Custom Outbound Caller ID Number",  // Label for the new field
      placeholder: "Custom Outbound Caller ID Number",  // Placeholder text
      disabled: false,  // Not disabled, user can edit
      buttonText: "Authenticate Number",
      labelWhenInputIsDisabled: "Number is Authenticated",
      validators: [Validators.maxLength(10), Validators.pattern(RegExHelper.phoneNumber)],
      errorMessages: {
        maxlength: "Phone number cannot be more than 10 characters.",
        pattern: "Phone number should be in right format.",
      },
      tooltip: "This is a custom number that can be configured to show on a receiving line as to where the call is coming from for outgoing calls made from the platform. Call backs will be routed to this number. To configure a number for use, it needs to go through authentication to be used through our call functionality. Please reach out to your support representative to facilitate setting this up for your organization as needed.",
    });
    this.contactDataInputs = [
      new Textbox({
        key: "telephone",
        label: "Contact Phone",
        placeholder: "Contact Phone",
        validators: [Validators.maxLength(20), Validators.pattern(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)],
        errorMessages: {
          maxlength: "Phone number can not be more than 20 characters.",
          pattern: "Phone number should be numeric only.",
        },
        tooltip: "This number will be displayed on provider packets as the callback number for recipients to contact.",
      }),
      new Textbox({
        key: "twilioPhoneNumber",
        label: "Outbound Call Number",
        placeholder: "Outbound Call Number",
        disabled: true,
        tooltip: "This number is used for calls made by users from the Reveleer platform. To configure or update this number, please contact Reveleer support.",
      }),
      this.callerIdValidationControl,
      new Textbox({
        key: "fax",
        label: "Fax",
        placeholder: "Fax",
        validators: [Validators.maxLength(20), Validators.pattern(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)],
        errorMessages: {
          maxlength: "Fax number can not be more than 20 characters.",
          pattern: "Fax number should be numeric only.",
        },
        tooltip: "This number will be displayed on provider packets as the designated fax number for recipients to fax documents.",
      }),
      new Textbox({
        key: "email",
        label: "Email",
        placeholder: "Email",
        validators: [Validators.email, Validators.maxLength(50)],
        errorMessages: {
          email: "Please enter a valid email address.",
          maxlength: "Email address can not be more than 50 characters.",
        },
      }),
    ];
    this.maxChaseCount = new Textbox({
      key: "maxChaseCount",
      label: "Enter Max Chase Assignment At One Time",
      placeholder: "Max Chase Assignment At One Time",
      value: "5",
      validators: [Validators.required, Validators.pattern(RegExHelper.number)],
      errorMessages: {
        required: "Max Chase Assignment At One Time.",
        pattern: "Max Chase Assignment at one time should be numeric only.",
      },
      tooltip: "For Member Centric Projects, all chases for that member will be counted as 1 assignment",
    });
    this.dailyMaxChaseCount = new Textbox({
      key: "dailyMaxChaseCount",
      label: "Enter Max Chase Assignment Per Day",
      placeholder: "Max Chase Assignment Per Day",
      value: "5",
      validators: [Validators.required, Validators.pattern(RegExHelper.number)],
      errorMessages: {
        required: "Max Chase Assignment Per Day.",
        pattern: "Max Chase Assignment Per Day should be numeric only.",
      },
    });

    this.reviewPagesOfChartInput = new Radiobutton({
      key: "reviewPagesOfChart",
      label: "Require users to review all pages of a chart before proceeding?",
      options: [
        { text: "Yes - Force users to confirm they have reviewed all pages", value: 1 },
        { text: "No - Users will NOT be required to review all pages", value: 0 },
      ],
    });

    this.persistAIDAssignmentInput = new Radiobutton({
      key: "persistAIDAssignment",
      label: "Maintain Address Assignments When There Are No Longer Active Retrieval Chases at an Address?",
      options: [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 },
      ],
      tooltip: "Yes - Maintain address assignment when all chases move out of retrieval statuses. When an active retrieval chase appears at this address, the address will be assigned to the user who was last assigned. \nNo - After all chases move out of retrieval statuses, the AID becomes unassigned. When an active retrieval chase appears at this address it will land back in the general queue to be reassigned as the previous assignment was cleared",
    });

    this.includeChartSiteIdInput = new Radiobutton({
      key: "incorporateCustomerAddressID",
      label: "Do you want to incorporate Customer Address ID in your AID rollup?",
      options: [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 },
      ],
      disabled: true,
      tooltip: "When set to ‘Yes’, AID rollup will incorporate the CustomerAddressID provided during data load. When set to ‘No’, AID rollup will be based on address 1, address 2, city, state, and zip. Speak with your CSM if you would like to change this setting.",
      skipTitleCase: true,
    });

    this.multiFactorAuthenticationInput = new Radiobutton({
      key: "multiFactorAuthenticationInput",
      label: "REQUIRE USERS TO USE MULTI-FACTOR AUTHENTICATION?",
      options: [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 },
      ],
    });

    this.groupNameInputs = [
      new Textbox({
        key: "groupName",
        label: "Group Name",
        validators: [Validators.required, Validators.maxLength(50)],
        errorMessages: {
          required: "Group name is required.",
          maxlength: "Group name can not be more than 50 characters.",

        },
      }),

    ];

    this.requestRejectedInput = new CheckboxGroup({
      key: "requestRejected",
      label: "Refusal / Request Rejected",
    });

    this.digitPendCodesInput = new CheckboxGroup({
      key: "digitPendCodes",
      label: "4-Digit Pend Codes: Codes used to Close Chases",
    });

    this.codesDataLoadsInput = new CheckboxGroup({
      key: "codesDataLoads",
      label: "Codes used during Data Loads",
    });

    this.customCreatedCodesInput = new CustomPendCheckboxGroup({
      key: "customCreatedCodes",
      label: "Custom Created Codes",
    });

    this.medicalRecordsInput = new CheckboxGroup({
      key: "medicalRecords",
      label: "Failure to Locate Medical Records",
    });

    this.providerIndicatesCannotRetrieveInput = new CheckboxGroup({
      key: "providerIndicatesCannotRetrieve",
      label: "Provider Response Indicates they Cannot Retrieve",
    });
    this.iVARiskSpecificInput = new CheckboxGroup({
      key: "iVARiskSpecific",
      label: "IVA / Risk Specific Pend Codes",
    });
    this.memberCentricInput = new CheckboxGroup({
      key: "memberCentricInput",
      label: "HEDIS Member Centric Specific",
    });
    this.clinicalCodesInput = new CheckboxGroup({
      key: "clinicalCodes",
      label: "Clinical Pend Codes",
    });

    this.generalCodesInput = new CheckboxGroup({
      key: "generalCodes",
      label: "General Pend Codes",
    });

    this.documentRoutingBulkUploadToggleInput = new Switch({
      key: "BulkUpload",
    });

    this.documentRoutingFaxToggleInput = new Switch({
      key: "Fax",
    });

    this.documentRoutingFTPToggleInput = new Switch({
      key: "FTP",
    });

    this.documentRoutingMailToggleInput = new Switch({
      key: "Mail",
    });

    this.documentRoutingProviderGatewayInput = new Switch({
      key: "ProviderEmail",
    });
    this.documentRoutingIntakeToggleInput = new Switch({
      key: "Intake",
    });

    this.documentRoutingForm = this.formService.createFormGroup([
      this.documentRoutingBulkUploadToggleInput,
      this.documentRoutingFaxToggleInput,
      this.documentRoutingFTPToggleInput,
      this.documentRoutingMailToggleInput,
      this.documentRoutingProviderGatewayInput,
      this.documentRoutingIntakeToggleInput,
    ]);


    this.providerEmailForm = this.formService.createFormGroup([
      this.providerAgingToggleInput,
      this.automatedOutreachToggleInput,
      this.daysBeforeOverdueInput,
      this.daysBeforeNextCallInput,
      this.emailSubjectInput,
    ]);

    this.serviceOrgForm = this.formService.createFormGroup(this.serviceOrgInputs);
    this.contactDataForm = this.formService.createFormGroup(this.contactDataInputs);
    this.organizationAttributeDataForm = this.formService.createFormGroup([this.maxChaseCount, this.dailyMaxChaseCount, this.reviewPagesOfChartInput,
                                                                           this.persistAIDAssignmentInput, this.multiFactorAuthenticationInput, this.includeChartSiteIdInput]);
    this.groupForm = this.formService.createFormGroup(this.groupNameInputs);
    this.providerEmailForm.addControl("emailBody", new FormControl(""));

    this.pendCodeManagerForm = this.formService.createFormGroup([
      this.requestRejectedInput,
      this.digitPendCodesInput,
      this.codesDataLoadsInput,
      this.customCreatedCodesInput,
      this.medicalRecordsInput,
      this.providerIndicatesCannotRetrieveInput,
      this.memberCentricInput,
      this.iVARiskSpecificInput,
      this.clinicalCodesInput,
      this.generalCodesInput,
    ]);


    this.ssoToggleInput = new Switch({
      key: "ssoToggleInput",
    });

    this.ssoOptionInput = new Radiobutton({
      key: "ssoOption",
      options: [
        { text: "Legacy", value: "legacy" },
        { text: "Auth0", value: "auth0" },
      ],
    });

    this.ssoInputsForm = this.formService.createFormGroup([this.ssoToggleInput, this.ssoOptionInput]);

    this.indentityProviderInput = new Dropdown({
      key: "indentityProviderInput",
      label: "Identity Provider (IdP)",
      placeholder: "Select...",
      validators: [Validators.required],
    });

    this.applicationIdInput = new Textbox({
      key: "applicationIdInput",
      label: "Application (Client) ID",
      validators: [Validators.required],
    });

    this.directoryIdInput = new Textbox({
      key: "directoryIdInput",
      label: "Directory (Tenant) ID",
      validators: [Validators.required],
    });

    this.ssoConfigForm = this.formService.createFormGroup([
      this.indentityProviderInput,
      this.applicationIdInput,
      this.directoryIdInput,
    ]);

    this.ssoDomainForm = this.fb.group({
      Domain: this.fb.array([
        new FormGroup({
          Domains: new FormControl(""),
        }),
      ]),
    });
  }

  ngOnInit() {
    this.getServiceOrgLogoUrl();
    this.service.getServiceOrgConfigurations().subscribe(configuration => {
      this.assignAndNotify(configuration);
    });
    this.searchPhraseInput = new Textbox({
      key: "SearchPhrase",
      placeholder: "Search",
    });
    this.searchPhraseForm = this.formService.createFormGroup([this.searchPhraseInput]);

    this.groupActionItems = [
      new ActionItem("Edit Group", "editGroup"),
    ];
    this.loadGroupGrid();
    this.createGroupGrid();
    this.isShowSearchIcon = true;
    this.loadMenuCategoryList();
    this.loadGrid(this.tagTypeId, this.startRecord, this.endRecord);
    this.actions = this.getActions();
    this.getOrganizationPendCode();
    this.getProviderAgingSampleImageUrl();
    this.getDocumentRouting();
    this.getEnableSso();
    this.getAuth0Enabled();
    this.getSsoConfiguration();

  }

  updateSsoForm(): void {
    const isAuth0Enabled = this.isAuth0Enabled;

    const isToggleOn = this.isLegacySSOSelected || isAuth0Enabled;

    let ssoOption: string | null = null;
    if (isAuth0Enabled) {
      ssoOption = "auth0";
      this.isSsoEnabled = true;
    } else if (this.isLegacySSOSelected) {
      ssoOption = "legacy";
    }

    this.ssoInputsForm.patchValue({
      ssoToggleInput: isToggleOn,
      ssoOption,
    });
  }


  tagGridUpdate(): void {
    this.loadGrid(this.tagTypeId, this.startRecord, this.endRecord);
    this.loadMenuCategoryList();
    this.searchPhraseForm.get(this.searchPhraseInput.key).reset();
  }
  pendCodeCategoryListUpdate(): void {
    this.getOrganizationPendCode();
  }

  loadGrid(tagType?: number, startRecord?: number, endRecord?: number) {
    this.service
      .getTagList(tagType, startRecord, endRecord)
      .subscribe(items => {
        if (items.length !== 0 && ArrayHelper.isAvailable(this.dashboardTagCount)) {
          this.totalRecords = NumberHelper.isAvailable(tagType) ?
            this.dashboardTagCount[0].tagDashboardCount.find(tag => tag.tagTypeId === tagType).tagCount :
            this.dashboardTagCount[0].tagCount;
        }

        this.rows = this.recordPerPage;
        this.tagGridRequest = items;
        this.showPagination = true;
        this.changeDetector.markForCheck();
      });
  }

  get serviceOrgText() {
    return `${this.serviceOrgTitle} Configuration`;
  }

  get disabledProviderEmail(): boolean {
    return (this.providerEmailForm.invalid && this.providerEmailForm.touched);
  }

  get disabledProperty(): boolean {
    return (this.serviceOrgForm.invalid && this.serviceOrgForm.touched) ||
      (this.contactDataForm.invalid && this.contactDataForm.touched);
  }

  get isAutomaticOutreachEnabled(): boolean {
    return this.providerEmailForm.get("automatedOutreachToggle").value;
  }

  assignAndNotify(data) {
    this.isOrganizationEnabledToDisplaySingleSignOnSettings = data.isOrganizationEnabledToDisplaySingleSignOnSettings;
    this.serviceOrgTitle = data.name;
    this.contactData = JSON.parse(data.contactData);
    this.organizationAttributeData = JSON.parse(data.organizationAttributeData).OrganizationAttribute
      .reduce((config, item) => {
        config[item.AttributeCode] = item;
        return config;
      },      {});
    this.loadDataIntoControls(data);
    this.changeDetector.markForCheck();
  }

  loadDataIntoControls(data) {
    this.serviceOrgForm.patchValue({
      name: data.name,
      contactName: data.contactName,
    });
    if (this.contactData) {
      this.contactData.ContactDataAttributes.forEach(value => {
        const key = value.Contacttype;
        if (key.toLowerCase() !== "customercalleridnumber") {
          this.contactDataForm.patchValue({
            [key]: value.Contactvalue,
          });
        }
      });
    }
    if (this.organizationAttributeData) {
      this.organizationAttributeDataForm.patchValue({
        maxChaseCount: this.organizationAttributeData.MaxChaseCount ? this.organizationAttributeData.MaxChaseCount.AttributeValue : null,
        dailyMaxChaseCount: this.organizationAttributeData.MaxDailyChaseCount ? this.organizationAttributeData.MaxDailyChaseCount.AttributeValue : null,
        reviewPagesOfChart: this.organizationAttributeData.ReviewAllPagesOfChart ? this.organizationAttributeData.ReviewAllPagesOfChart.AttributeValue : null,
        persistAIDAssignment: this.organizationAttributeData.PersistAIDAssignmentEnabled ? this.organizationAttributeData.PersistAIDAssignmentEnabled.AttributeValue : null,
        incorporateCustomerAddressID: this.organizationAttributeData.IncorporateCustomerAddressID ? this.organizationAttributeData.IncorporateCustomerAddressID.AttributeValue : null,
        multiFactorAuthenticationInput: this.organizationAttributeData.MultiFactorAuthenticationEnabled ? this.organizationAttributeData.MultiFactorAuthenticationEnabled.AttributeValue : null,
        enableDocumentSyncInput: this.organizationAttributeData.EnableDocumentSyncAcrossProjects ? Number(this.organizationAttributeData.EnableDocumentSyncAcrossProjects.AttributeValue) : null,
        enableDocumentSyncAcrossAddressInput: this.organizationAttributeData.EnableDocumentSyncAcrossAddress
          ? Number(this.organizationAttributeData.EnableDocumentSyncAcrossAddress.AttributeValue)
          : null,
      });
    }

    this.contactDataForm.patchValue({ twilioPhoneNumber: this.organizationAttributeData?.TwilioPhoneNumber ? this.organizationAttributeData.TwilioPhoneNumber.AttributeValue : "Not Configured" });
    this.contactDataForm.patchValue({ customerOutboundCallerIdNumber: this.organizationAttributeData?.CustomerOutboundCallerIDNumber?.AttributeValue || "" });
    this.callerIdValidationControl.disabled = this.organizationAttributeData.IsCallerIDAuthenticated.AttributeValue !== "0";
    this.changeDetector.detectChanges();

    this.providerEmailForm.patchValue({
      providerAgingToggle: this.organizationAttributeData.ProviderAgingStatement ? Number(this.organizationAttributeData.ProviderAgingStatement.AttributeValue) === 1 : null,
      automatedOutreachToggle: this.organizationAttributeData.AutomatedOutreachEnabled ? Number(this.organizationAttributeData.AutomatedOutreachEnabled.AttributeValue) === 1 : null,
      daysBeforeOverdue: this.organizationAttributeData.AutomatedOutreachDaysBeforeOverdue ? this.organizationAttributeData.AutomatedOutreachDaysBeforeOverdue.AttributeValue : null,
      daysBeforeNextCall: this.organizationAttributeData.AutoOutreachDaysBeforeNextCall ? this.organizationAttributeData.AutoOutreachDaysBeforeNextCall.AttributeValue : null,
      emailSubject: this.organizationAttributeData.ProviderEmailSubject ? this.organizationAttributeData.ProviderEmailSubject.AttributeValue : null,
      emailBody: this.organizationAttributeData.ProviderEmailBody ? this.organizationAttributeData.ProviderEmailBody.AttributeValue : null,
    });

    this.updateSsoForm();

    this.changeDetector.markForCheck();
  }

  saveSOAttributes() {
    this.createServiceOrgSummaryModel()
      .then((model: any) => {
        this.formData = new FormData();
        this.formData.append("companyLogo", this.selectedFile[0]);
        model.companyLogo = this.formData;

        this.service
          .saveServiceOrgConfigurations(model)
          .subscribe(() => {
            this.messagingService.showToast("Organization configuration saved.", SeverityType.SUCCESS);
            this.getServiceOrgLogoUrl();
          },         () => {
            this.messagingService.showToast("Failed to save Organization configuration.", SeverityType.ERROR);
          });
      })
      .catch(() => {
        this.messagingService.showToast("Error in creating model.", SeverityType.ERROR);
      });
  }

  saveServiceOrgConfiguration() {
    if (this.presignedUrlForLogo) {
      this.service.uploadLogo(this.presignedUrlForLogo, this.logoFile).then(() => {
        this.saveSOAttributes();
      });
    } else {
      this.saveSOAttributes();
    }
  }

  getClassIcon(value): string {
    switch (value.tagTypeId) {
      case 1:
        return "tag-icon-chase";

      case 2:
        return "tag-icon-address";

      case 3:
        return "tag-icon-document";
      default:
        return "";

    }


  }

  getIcon(value): string {

    switch (value.tagTypeId) {
      case 1:
        return "fal fa-file-alt";
        break;
      case 2:
        return "fal fa-map-marker-plus";
        break;
      case 3:
        return "fal fa-files-medical";
      default:
        return "";
        break;
    }


  }

  get checkCount(): boolean {
    return this.tagGridRequest.length > 24 ? true : this.tagPageNumber > 0;
  }

  fetchTextMatches(): void {
    this.tagPageNumber = 0;
    this.startRecord = 0;
    this.endRecord = 25;
    this.tagTypeName = "All Tags";
    const searchName = StringHelper.isAvailable(this.searchPhraseForm.get(this.searchPhraseInput.key).value)
      ? this.searchPhraseForm.get(this.searchPhraseInput.key).value : "";
    this.service
      .getTagSearchList(null, searchName, this.startRecord, this.endRecord)
      .subscribe(data => {
        this.tagGridRequest = data;
        if (data.length !== 0) {
          this.totalRecords = data[0].recordCount;
        }
        this.rows = this.recordPerPage;
        this.isShowSearchIcon = false;
        if (!this.searchPhraseForm.get(this.searchPhraseInput.key).value) {
          this.isShowSearchIcon = true;
        }
        this.changeDetector.markForCheck();
      });
  }

  resetSearchInput(): void {
    this.loadGrid(null, this.startRecord, this.endRecord);
    this.searchPhraseForm.get(this.searchPhraseInput.key).reset();
    this.isShowSearchIcon = true;
    this.hasSearchResult = true;
    this.setTagType(null, "All Tags");
  }

  onInputSearchText(): void {
    this.searchPhraseForm.get(this.searchPhraseInput.key).valueChanges.pipe(
      distinctUntilChanged(),
      pairwise()
    ).subscribe(([oldSearchValue, newSearchValue]) => {
      if (oldSearchValue !== newSearchValue) {
        this.isShowSearchIcon = true;
        this.hasSearchResult = false;
      }
    });
  }

  private setAttrValue(key: string, value: any): void {
    if (this.organizationAttributeData[key]) {
      this.organizationAttributeData[key].AttributeValue = value;
    }
  }

  private setOrCreateAttr(key: string, value: any, defaults?: { AttributeCode: string; AttributeID: number }): void {
    if (this.organizationAttributeData[key]) {
      this.organizationAttributeData[key].AttributeValue = value;
    } else if (defaults) {
      this.organizationAttributeData[key] = { AttributeValue: value, ...defaults };
    }
  }

  private setAttrWithDefault(key: string, form: FormGroup, controlName: string, defaultValue: string): void {
    if (this.organizationAttributeData[key]) {
      if (StringHelper.isAvailable(form.controls[controlName].value)) {
        this.organizationAttributeData[key].AttributeValue = form.controls[controlName].value;
      } else {
        this.organizationAttributeData[key].AttributeValue = defaultValue;
        form.get(controlName).setValue(defaultValue);
      }
    }
  }


  createServiceOrgSummaryModel() {
    return new Promise<ServiceOrgConfigModel>(async (resolve, reject) => {
      try {
        const model = new ServiceOrgConfigModel(this.serviceOrgForm.value);

        const contactDataToSend = Object.keys(this.contactDataForm.value).reduce((acc, key) => {
          if (key !== "customerOutboundCallerIdNumber") {
            acc.push({ Contacttype: key, Contactvalue: this.contactDataForm.value[key] });
          }
          return acc;
        },                                                                       []);

        model.contactData = JSON.stringify({
          ContactDataAttributes: contactDataToSend,
        });

        // Set organization attributes
        this.setAttrValue("MaxChaseCount", this.organizationAttributeDataForm.controls.maxChaseCount.value);
        this.setAttrValue("MaxDailyChaseCount", this.organizationAttributeDataForm.controls.dailyMaxChaseCount.value);
        this.setAttrValue("ReviewAllPagesOfChart", this.organizationAttributeDataForm.controls.reviewPagesOfChart.value);
        this.setAttrValue("PersistAIDAssignmentEnabled", this.organizationAttributeDataForm.controls.persistAIDAssignment.value);
        this.setAttrValue("MultiFactorAuthenticationEnabled", this.organizationAttributeDataForm.controls.multiFactorAuthenticationInput.value);
        this.setAttrValue("IncorporateCustomerAddressID", this.organizationAttributeDataForm.controls.incorporateCustomerAddressID.value);
        this.setAttrValue("ProviderEmailSubject", this.providerEmailForm.controls.emailSubject.value);
        this.setAttrValue("CustomLogo", this.normalizedFileName || this.organizationAttributeData.CustomLogo?.AttributeValue);
        this.setAttrValue("ProviderAgingStatement", this.providerEmailForm.controls.providerAgingToggle.value ? 1 : 0);
        this.setAttrValue("AutomatedOutreachEnabled", this.providerEmailForm.controls.automatedOutreachToggle.value ? 1 : 0);

        // Sanitized email body
        if (this.organizationAttributeData.ProviderEmailBody) {
          const sanitizedEmailBody = this.domSanitizer.sanitize(SecurityContext.HTML, this.providerEmailForm.controls.emailBody.value);
          this.organizationAttributeData.ProviderEmailBody.AttributeValue = sanitizedEmailBody;
        }

        // Fields with fallback defaults
        this.setAttrWithDefault("AutomatedOutreachDaysBeforeOverdue", this.providerEmailForm, "daysBeforeOverdue", "21");
        this.setAttrWithDefault("AutoOutreachDaysBeforeNextCall", this.providerEmailForm, "daysBeforeNextCall", this.defaultDaysBeforeNextCall);


        if (this.isSsoEnabled) {
          // Auth0 — create if missing
          this.setOrCreateAttr(
            "Auth0Enabled",
            this.ssoInputsForm.get("ssoOption")?.value === "auth0" ? 1 : 0,
            { AttributeCode: AUTH0ENABLED.attributeCode, AttributeID: AUTH0ENABLED.attributeId }
          );
        }

        this.removeTwilioPhoneNumber();

        // Wait for confirmCallerId to complete before proceeding
        await this.confirmCallerId(this.contactDataForm.controls.customerOutboundCallerIdNumber.value, false);

        // After confirmCallerId finishes, update caller ID attributes
        this.updateCallerIdAttributes();

        // Prepare organization attributes for the model
        const orgAttribute = Object.keys(this.organizationAttributeData).map(
          item => this.organizationAttributeData[item]
        );

        model.organizationAttributeData = JSON.stringify({
          OrganizationAttribute: orgAttribute,
        });

        resolve(model);
      } catch (error) {
        reject(error);
      }
    });
  }

  private removeTwilioPhoneNumber() {
    if (this.organizationAttributeData && this.organizationAttributeData.TwilioPhoneNumber) {
      delete this.organizationAttributeData.TwilioPhoneNumber;
    }
  }

  // Helper method to update caller ID attributes
  private updateCallerIdAttributes() {
    if (this.organizationAttributeData && this.organizationAttributeData.CustomerOutboundCallerIDNumber) {
      this.organizationAttributeData.CustomerOutboundCallerIDNumber.AttributeValue = this.contactDataForm.controls.customerOutboundCallerIdNumber.value;
    }
    if (this.organizationAttributeData && this.organizationAttributeData.IsCallerIDAuthenticated) {
      this.organizationAttributeData.IsCallerIDAuthenticated.AttributeValue = this.callerIdVerificationStatus === true ? 1 : 0;
    }
  }
  setTagType(tagType: number, tag: string) {
    this.showPagination = false;
    this.tagPageNumber = 0;
    this.startRecord = 0;
    this.endRecord = 25;
    this.tagTypeName = tag;
    this.setSelectedTagType = (this.tagTypeName === this.selectedTagTab) ? this.tagTypeName : "";

    this.tagTypeId = tagType;
    this.searchPhraseForm.get(this.searchPhraseInput.key).reset();
    this.loadGrid(this.tagTypeId, this.startRecord, this.endRecord);
  }

  get selectedTagTab(): string {
    return StringHelper.isAvailable(this.selectedTag) ? this.selectedTag : "All Tags";
  }
  selectedTagType(tagTypeValue: string, isFirstElement: boolean, selectedTagValue: string): string {
    let className = "";

    if (isFirstElement && this.selectedTagTab === "All Tags") {
      className = this.setSelectedTagType === "" ? "" : "tab-category-first-menu-element";
    }
    if (this.tagTypeName === selectedTagValue) {
      className = "tag li selected";
    }
    return className;
  }

  getClass(categoryValue: string): string {
    let categoryClass = "category__label";
    switch (categoryValue) {

      case "Address":
        return categoryClass += " --address";

      case "Chase":
        return categoryClass += " --chase";

      case "Document":
        return categoryClass += " --document";

      default:
        return "";
    }
  }


  toggleTab(tab: string): void {
    this.selectedTab = this.selectedTab === tab ? "" : tab;
  }

  isSelectedTab(tabName: string): boolean {
    return this.selectedTab === tabName;
  }

  trackByIndex(index, item) {
    return index;
  }

  createGroupGrid(): void {
    this.groupGridConfiguration.columns = [
      new GridColumnDefinition({ field: "name", header: "Group" }),
      new GridColumnDefinition({ field: "clientId", header: "Customer ID" }),
    ];
    this.groupGridConfiguration.pageSize = 25;
    this.groupGridConfiguration.showActionColumn = true;
    this.groupGridConfiguration.showExportAction = false;
  }

  loadGroupGrid(): void {
    this.groupGridRequest = new GridRequest({
      url: `${this.baseApiUrl}serviceorg/clients/name`,
    });
  }

  groupGridActions(rowData: any): void {

    this.groupId = rowData.clientId;
    this.groupName = rowData.name;
    this.groupModalHeader = "Edit Group Name";
    this.groupAction = "Edit";
    this.groupForm = this.formBuild.group({
      groupName: [this.groupName, [Validators.required, Validators.maxLength(50)]],
    });

    this.isGroupModalVisible = true;
  }

  saveGroupName() {
    const checkgroupName = this.groupForm.controls.groupName.value;
    if (!this.groupForm.valid) {
      if (checkgroupName.length > 50) {
        this.messagingService.showToast("Group name can not be more than 50 characters.", SeverityType.ERROR);
        return;
      }
      this.messagingService.showToast("Please enter group name.", SeverityType.ERROR);
      return;
    }

    const groupDetail = new ClientOrgModel({
      name: this.groupForm.controls.groupName.value,
      clientId: this.groupId,
    });

    if (checkgroupName.length === 0 || !checkgroupName.trim()) {

      this.messagingService.showToast("Empty field is not allowed. Please enter group name.", SeverityType.ERROR);
      this.groupForm.reset();
    } else {
      this.service
        .saveClientName(groupDetail)
        .subscribe(() => {
          this.refreshGrid();
          const addEditMode = this.groupId > 0 ? "edited" : "added";
          this.messagingService.showToast(`Group name ${addEditMode} successfully.`, SeverityType.SUCCESS);
          this.isGroupModalVisible = false;
          this.groupForm.reset();
          this.changeDetector.markForCheck();
        });
    }
  }

  createNewTag(): void {
    this.setHeader(this.createNewHeader);
    this.entityName = "Create";
    this.isManageTagModalVisible = true;
    this.isCreateTag = true;
    this.isEditTags = false;
    this.isDeleteTag = false;
    this.isReplaceTag = false;
    this.tagAction = TagActionType.ADD;
    this.editTagObj = null;
  }

  editTag(data: Tags): void {
    this.setHeader(data.tagTypeId);
    this.entityName = "Edit";
    this.isManageTagModalVisible = true;
    this.isEditTags = true;
    this.isCreateTag = false;
    this.isDeleteTag = false;
    this.isReplaceTag = false;
    this.tagAction = TagActionType.EDIT;

    this.editTagObj = data;
  }
  deleteTags(data: Tags): void {
    this.setHeader(data.tagTypeId);
    this.entityName = "Delete";
    this.isManageTagModalVisible = true;
    this.isEditTags = false;
    this.isDeleteTag = true;
    this.isCreateTag = false;
    this.isReplaceTag = false;
    this.tagAction = TagActionType.DELETE;

    this.editTagObj = data;
  }

  replaceTags(data: Tags): void {
    this.setHeader(data.tagTypeId);
    this.entityName = "Replace";
    this.isManageTagModalVisible = true;
    this.isEditTags = false;
    this.isDeleteTag = false;
    this.isCreateTag = false;
    this.isReplaceTag = true;
    this.tagAction = TagActionType.REPLACE;

    this.editTagObj = data;
  }

  setHeader(val): string {
    let getheader;
    switch (val) {
      case 1:
        getheader = "Chase";
        break;
      case 2:
        getheader = "Address";
        break;
      case 3:
        getheader = "Documents";
        break;
      default:
        getheader = "New";
        break;

    }
    this.headerSet = getheader;

    return getheader;
  }

  private getActions(): BulkAction[] {
    const bulkActions = [
      new BulkAction({
        name: "Edit Tag Name",
        action: this.editTag.bind(this), // this.editTags.bind(this),
      }),
      new BulkAction({
        name: "Delete Tag",
        action: this.deleteTags.bind(this),
      }),
      new BulkAction({
        name: "Replace Tag",
        action: this.replaceTags.bind(this),
      }),
    ];
    return bulkActions;
  }
  loadMenuCategoryList(): void {
    this.service
      .getDashboardCount()
      .subscribe(result => {
        this.dashboardTagCount = result;
        this.changeDetector.markForCheck();
      });
  }


  addNewGroup(): void {
    this.groupModalHeader = "Add New Group";
    this.groupAction = "Add";
    this.groupId = null;
    this.groupForm.reset();
    this.isGroupModalVisible = true;
  }

  getTagIcon(): string {
    return "far fa-plus-circle";
  }

  getPendCodeIcon(): string {
    return "far fa-plus-circle";
  }

  getClassForPlusIcon(): string {
    return "add-document-icon";
  }

  getRemoveIcon() {
    return "fal fa-times-circle";
  }

  private refreshGrid(): void {
    this.gridRefresh.emit();
  }

  selectedTabs(tabName: string): string {
    return this.selectedTab === tabName ? "active" : "";
  }

  getPendCodes(categoryId: number): void {
    this.categoryId = categoryId;
    this.service
      .getPendCodeByCategory(categoryId)
      .pipe(map((result: any) => {
        return result.map(item => new SelectableInput({
          text: `${item.pendCode}-${item.pendName}`,
          value: item.pendTypeId,
          extra: item.pendTypeCategoryId,
          disabled: this.isPendCodeLocked(item.pendCode),
        }));
      }))
      .subscribe(options => {
        this.pendCodeType(categoryId, options);
      });
  }

  loadPendCodeCategoryList(): void {
    this.service
      .getPendCodeDashboardCount()
      .subscribe(result => {
        this.dashboardPendCodeCount = result;
        this.getPendCodes(this.categoryId);
        this.changeDetector.markForCheck();
      });
  }

  selectedPendType(selectedpendValue: number): string {
    let className = "";
    if (this.pendCodeCategories === selectedpendValue) {
      className = "pend li selected";
    }
    return className;
  }

  createNewPendCode(): void {
    this.isPendModalVisible = true;
    this.isEditPendCode = false;
  }


  onPageChange(event) {
    this.tagPageNumber = event.page;
    this.startRecord = ((event.page) * this.recordPerPage) + 1;
    this.endRecord = this.startRecord + (this.recordPerPage - 1);
    this.loadGrid(this.tagTypeId, this.startRecord, this.endRecord);
  }

  setCountHeader(val): string {
    let getheader;
    switch (val) {
      case 1:
        getheader = "Chase";
        break;
      case 2:
        getheader = "Address";
        break;
      case 3:
        getheader = "Documents";
        break;
      default:
        getheader = "New";
        break;

    }

    return getheader;
  }

  pendCodeType(pendCodeTypeId: number, pendCodeCategoryList: SelectableInput[]): void {
    this.pendCodeCategories = pendCodeTypeId;

    switch (pendCodeTypeId) {
      case PendCategories.ALL_PEND_CODES:
        this.isAllPendCodes = true;

        let options = pendCodeCategoryList.filter(x => x.extra === PendCategories.REFUSAL_REQUEST_REJECTED);
        this.requestRejectedInput = {
          ...this.requestRejectedInput, options,
          selectedOptions: this.getSelectedPendCode(PendCategories.REFUSAL_REQUEST_REJECTED, this.requestRejectedInput.key),
        } as any;
        this.isRefusalRequestRejected = true;

        options = pendCodeCategoryList.filter(x => x.extra === PendCategories.FOUR_DIGIT_PEND_CODES);
        this.digitPendCodesInput = {
          ...this.digitPendCodesInput, options,
          selectedOptions: this.getSelectedPendCode(PendCategories.FOUR_DIGIT_PEND_CODES, this.digitPendCodesInput.key),
        } as any;
        this.pendCodeManagerForm.get(this.digitPendCodesInput.key).setValue(options);
        this.is4DigitPendCodes = true;

        options = pendCodeCategoryList.filter(x => x.extra === PendCategories.CODES_USED_DURING_DATA_LOADS);
        this.codesDataLoadsInput = {
          ...this.codesDataLoadsInput, options,
          selectedOptions: this.getSelectedPendCode(PendCategories.CODES_USED_DURING_DATA_LOADS, this.codesDataLoadsInput.key),
        } as any;
        this.isCodesDataLoads = true;

        options = pendCodeCategoryList.filter(x => x.extra === PendCategories.CUSTOM_CREATED_CODES);
        this.customCreatedCodesInput = {
          ...this.customCreatedCodesInput, options,
          selectedOptions: this.getSelectedPendCode(PendCategories.CUSTOM_CREATED_CODES, this.customCreatedCodesInput.key),
        } as any;
        this.isCustomPendCodes = true;
        this.hasCustomPendCodes = options.length > 0;

        options = pendCodeCategoryList.filter(x => x.extra === PendCategories.FAILURE_TO_LOCATE_MEDICAL_RECORDS);
        this.medicalRecordsInput = {
          ...this.medicalRecordsInput,
          options, selectedOptions: this.getSelectedPendCode(PendCategories.FAILURE_TO_LOCATE_MEDICAL_RECORDS, this.medicalRecordsInput.key),
        } as any;
        this.isFailureMedicalRecords = true;

        options = pendCodeCategoryList.filter(x => x.extra === PendCategories.PROVIDER_INDICATES_CANNOT_RETERIEVE);
        this.providerIndicatesCannotRetrieveInput = {
          ...this.providerIndicatesCannotRetrieveInput,
          options, selectedOptions: this.getSelectedPendCode(PendCategories.PROVIDER_INDICATES_CANNOT_RETERIEVE, this.providerIndicatesCannotRetrieveInput.key),
        } as any;
        this.isProviderIndicates = true;

        options = pendCodeCategoryList.filter(x => x.extra === PendCategories.MEMBER_CENTRIC);
        this.memberCentricInput = { ...this.memberCentricInput, options, selectedOptions: this.getSelectedPendCode(PendCategories.MEMBER_CENTRIC, this.memberCentricInput.key) } as any;
        this.isMemberCentric = true;

        options = pendCodeCategoryList.filter(x => x.extra === PendCategories.IVA_RISK_SPECIFIC);
        this.iVARiskSpecificInput = { ...this.iVARiskSpecificInput, options, selectedOptions: this.getSelectedPendCode(PendCategories.IVA_RISK_SPECIFIC, this.iVARiskSpecificInput.key) } as any;
        this.isIVARisk = true;

        options = pendCodeCategoryList.filter(x => x.extra === PendCategories.CLINICAL_CODES);
        this.clinicalCodesInput = { ...this.clinicalCodesInput, options, selectedOptions: this.getSelectedPendCode(PendCategories.CLINICAL_CODES, this.clinicalCodesInput.key) } as any;
        this.pendCodeManagerForm.get(this.clinicalCodesInput.key).setValue(options);
        this.isClinical = true;

        options = pendCodeCategoryList.filter(x => x.extra === PendCategories.GENERAL_CODES);
        this.generalCodesInput = { ...this.generalCodesInput, options, selectedOptions: this.getSelectedPendCode(PendCategories.GENERAL_CODES, this.generalCodesInput.key) } as any;
        this.isGeneralCodes = true;

        break;

      case PendCategories.REFUSAL_REQUEST_REJECTED:
        this.requestRejectedInput = {
          ...this.requestRejectedInput, options: pendCodeCategoryList,
          selectedOptions: this.getSelectedPendCode(PendCategories.REFUSAL_REQUEST_REJECTED, this.requestRejectedInput.key),
        } as any;
        this.isAllPendCodes = false;
        this.isRefusalRequestRejected = true;
        this.is4DigitPendCodes = false;
        this.isCodesDataLoads = false;
        this.isCustomPendCodes = false;
        this.isFailureMedicalRecords = false;
        this.isProviderIndicates = false;
        this.isIVARisk = false;
        this.isMemberCentric = false;
        this.isClinical = false;
        this.isGeneralCodes = false;
        break;
      case PendCategories.FOUR_DIGIT_PEND_CODES:
        this.digitPendCodesInput = {
          ...this.digitPendCodesInput, options: pendCodeCategoryList,
          selectedOptions: this.getSelectedPendCode(PendCategories.FOUR_DIGIT_PEND_CODES, this.digitPendCodesInput.key),
        } as any;
        this.pendCodeManagerForm.get(this.digitPendCodesInput.key).setValue(pendCodeCategoryList);
        this.isAllPendCodes = false;
        this.isRefusalRequestRejected = false;
        this.is4DigitPendCodes = true;
        this.isCodesDataLoads = false;
        this.isCustomPendCodes = false;
        this.isFailureMedicalRecords = false;
        this.isProviderIndicates = false;
        this.isIVARisk = false;
        this.isMemberCentric = false;
        this.isClinical = false;
        this.isGeneralCodes = false;
        break;
      case PendCategories.CODES_USED_DURING_DATA_LOADS:
        this.codesDataLoadsInput = {
          ...this.codesDataLoadsInput, options: pendCodeCategoryList,
          selectedOptions: this.getSelectedPendCode(PendCategories.CODES_USED_DURING_DATA_LOADS, this.codesDataLoadsInput.key),
        } as any;
        this.isAllPendCodes = false;
        this.isRefusalRequestRejected = false;
        this.is4DigitPendCodes = false;
        this.isCodesDataLoads = true;
        this.isCustomPendCodes = false;
        this.isFailureMedicalRecords = false;
        this.isProviderIndicates = false;
        this.isIVARisk = false;
        this.isMemberCentric = false;
        this.isClinical = false;
        this.isGeneralCodes = false;
        break;
      case PendCategories.CUSTOM_CREATED_CODES:
        this.customCreatedCodesInput = {
          ...this.customCreatedCodesInput, options: pendCodeCategoryList,
          selectedOptions: this.getSelectedPendCode(PendCategories.CUSTOM_CREATED_CODES, this.customCreatedCodesInput.key),
        } as any;
        this.isAllPendCodes = false;
        this.isRefusalRequestRejected = false;
        this.is4DigitPendCodes = false;
        this.isCodesDataLoads = false;
        this.isCustomPendCodes = true;
        this.isFailureMedicalRecords = false;
        this.isProviderIndicates = false;
        this.isIVARisk = false;
        this.isMemberCentric = false;
        this.isClinical = false;
        this.isGeneralCodes = false;
        this.hasCustomPendCodes = this.customCreatedCodesInput.options.length > 0;
        break;
      case PendCategories.FAILURE_TO_LOCATE_MEDICAL_RECORDS:
        this.medicalRecordsInput = {
          ...this.medicalRecordsInput, options: pendCodeCategoryList,
          selectedOptions: this.getSelectedPendCode(PendCategories.FAILURE_TO_LOCATE_MEDICAL_RECORDS, this.medicalRecordsInput.key),
        } as any;
        this.isAllPendCodes = false;
        this.isRefusalRequestRejected = false;
        this.is4DigitPendCodes = false;
        this.isCodesDataLoads = false;
        this.isCustomPendCodes = false;
        this.isFailureMedicalRecords = true;
        this.isProviderIndicates = false;
        this.isIVARisk = false;
        this.isMemberCentric = false;
        this.isClinical = false;
        this.isGeneralCodes = false;
        break;
      case PendCategories.PROVIDER_INDICATES_CANNOT_RETERIEVE:
        this.providerIndicatesCannotRetrieveInput = {
          ...this.providerIndicatesCannotRetrieveInput, options: pendCodeCategoryList,
          selectedOptions: this.getSelectedPendCode(PendCategories.PROVIDER_INDICATES_CANNOT_RETERIEVE, this.providerIndicatesCannotRetrieveInput.key),
        } as any;
        this.isAllPendCodes = false;
        this.isRefusalRequestRejected = false;
        this.is4DigitPendCodes = false;
        this.isCodesDataLoads = false;
        this.isCustomPendCodes = false;
        this.isFailureMedicalRecords = false;
        this.isProviderIndicates = true;
        this.isIVARisk = false;
        this.isMemberCentric = false;
        this.isClinical = false;
        this.isGeneralCodes = false;
        break;
      case PendCategories.IVA_RISK_SPECIFIC:
        this.iVARiskSpecificInput = {
          ...this.iVARiskSpecificInput, options: pendCodeCategoryList,
          selectedOptions: this.getSelectedPendCode(PendCategories.IVA_RISK_SPECIFIC, this.iVARiskSpecificInput.key),
        } as any;
        this.isAllPendCodes = false;
        this.isRefusalRequestRejected = false;
        this.is4DigitPendCodes = false;
        this.isCodesDataLoads = false;
        this.isCustomPendCodes = false;
        this.isFailureMedicalRecords = false;
        this.isProviderIndicates = false;
        this.isIVARisk = true;
        this.isClinical = false;
        this.isGeneralCodes = false;
        break;
      case PendCategories.MEMBER_CENTRIC:
        this.memberCentricInput = {
          ...this.memberCentricInput, options: pendCodeCategoryList,
          selectedOptions: this.getSelectedPendCode(PendCategories.MEMBER_CENTRIC, this.memberCentricInput.key),
        } as any;
        this.pendCodeManagerForm.get(this.memberCentricInput.key).setValue(pendCodeCategoryList);
        this.pendCodeCategories = pendCodeTypeId;
        this.isAllPendCodes = false;
        this.isRefusalRequestRejected = false;
        this.is4DigitPendCodes = false;
        this.isCodesDataLoads = false;
        this.isCustomPendCodes = false;
        this.isFailureMedicalRecords = false;
        this.isProviderIndicates = false;
        this.isIVARisk = false;
        this.isMemberCentric = true;
        this.isClinical = false;
        this.isGeneralCodes = false;
        break;
      case PendCategories.CLINICAL_CODES:
        this.clinicalCodesInput = {
          ...this.clinicalCodesInput, options: pendCodeCategoryList,
          selectedOptions: this.getSelectedPendCode(PendCategories.CLINICAL_CODES, this.clinicalCodesInput.key),
        } as any;
        this.pendCodeManagerForm.get(this.clinicalCodesInput.key).setValue(pendCodeCategoryList);
        this.pendCodeCategories = pendCodeTypeId;
        this.isAllPendCodes = false;
        this.isRefusalRequestRejected = false;
        this.is4DigitPendCodes = false;
        this.isCodesDataLoads = false;
        this.isCustomPendCodes = false;
        this.isFailureMedicalRecords = false;
        this.isProviderIndicates = false;
        this.isIVARisk = false;
        this.isMemberCentric = false;
        this.isClinical = true;
        this.isGeneralCodes = false;
        break;
      default:
        this.generalCodesInput = {
          ...this.generalCodesInput, options: pendCodeCategoryList,
          selectedOptions: this.getSelectedPendCode(PendCategories.GENERAL_CODES, this.generalCodesInput.key),
        } as any;
        this.isAllPendCodes = false;
        this.isRefusalRequestRejected = false;
        this.is4DigitPendCodes = false;
        this.isCodesDataLoads = false;
        this.isCustomPendCodes = false;
        this.isFailureMedicalRecords = false;
        this.isProviderIndicates = false;
        this.isIVARisk = false;
        this.isMemberCentric = false;
        this.isClinical = false;
        this.isGeneralCodes = true;
        break;
    }
    this.formService.updateDom.next();
  }

  savePendCode(): void {
    const pendCodeCsv = this.getPendCode();
    const organizationPendCode = new OrganizationPendCode({ pendCodesCsv: pendCodeCsv, inActivePendCodesCsv: this.inActivePendCodeList });
    this.service.savePendCods(organizationPendCode)
      .subscribe(() => {
        this.messagingService.showToast("Pend Codes updated successfully.", SeverityType.SUCCESS);
        this.getOrganizationPendCode();
      });
  }


  getPendCode(): string {
    const pendCodes = [];
    pendCodes.push(this.pendCodeManagerForm.get(this.requestRejectedInput.key).value);
    pendCodes.push(this.pendCodeManagerForm.get(this.digitPendCodesInput.key).value);
    pendCodes.push(this.pendCodeManagerForm.get(this.codesDataLoadsInput.key).value);
    pendCodes.push(this.pendCodeManagerForm.get(this.customCreatedCodesInput.key).value);
    pendCodes.push(this.pendCodeManagerForm.get(this.medicalRecordsInput.key).value);
    pendCodes.push(this.pendCodeManagerForm.get(this.providerIndicatesCannotRetrieveInput.key).value);
    pendCodes.push(this.pendCodeManagerForm.get(this.memberCentricInput.key).value);
    pendCodes.push(this.pendCodeManagerForm.get(this.iVARiskSpecificInput.key).value);
    pendCodes.push(this.pendCodeManagerForm.get(this.clinicalCodesInput.key).value);
    pendCodes.push(this.pendCodeManagerForm.get(this.generalCodesInput.key).value);
    let pendCodesCsv = "";
    for (const selectedPendCode of pendCodes) {
      if (ArrayHelper.isAvailable(selectedPendCode)) {
        pendCodesCsv += `,${this.service.getValueForPendCodeAsCsv(selectedPendCode, true)}`;
      }
    }

    return pendCodesCsv.substring(1);
  }

  getOrganizationPendCode(): void {
    this.createPendService
      .getPendDropdown(this.pendType)
      .subscribe(result => {
        this.pendCodeList = result.pendCodes;
        const pendCodeList = result.pendCodes.map(item => new SelectableInput({
          text: `${item.pendCode}-${item.pendName}`,
          value: item.pendTypeId,
        }));
        this.inActivePendCodeList = this.service.getValueForPendCodeAsCsv(pendCodeList, true);
        this.getSelectedPendCode(PendCategories.REFUSAL_REQUEST_REJECTED, this.requestRejectedInput.key, true);
        this.getSelectedPendCode(PendCategories.CODES_USED_DURING_DATA_LOADS, this.codesDataLoadsInput.key, true);
        this.getSelectedPendCode(PendCategories.CUSTOM_CREATED_CODES, this.customCreatedCodesInput.key, true);
        this.getSelectedPendCode(PendCategories.FAILURE_TO_LOCATE_MEDICAL_RECORDS, this.medicalRecordsInput.key, true);
        this.getSelectedPendCode(PendCategories.PROVIDER_INDICATES_CANNOT_RETERIEVE, this.providerIndicatesCannotRetrieveInput.key, true);
        this.getSelectedPendCode(PendCategories.MEMBER_CENTRIC, this.memberCentricInput.key, true);
        this.getSelectedPendCode(PendCategories.IVA_RISK_SPECIFIC, this.iVARiskSpecificInput.key, true);
        this.getSelectedPendCode(PendCategories.CLINICAL_CODES, this.clinicalCodesInput.key, true);
        this.getSelectedPendCode(PendCategories.GENERAL_CODES, this.generalCodesInput.key, true);
        this.getSelectedPendCode(PendCategories.FOUR_DIGIT_PEND_CODES, this.digitPendCodesInput.key, true);
        this.loadPendCodeCategoryList();
        this.formService.updateDom.next();
      });
  }

  getSelectedPendCode(pendCategory: number, key: string, isSelectedPend?: boolean): SelectableInput[] {
    const pendCode = this.pendCodeList.filter(c => c.pendTypeCategoryId === pendCategory);
    let selectedOption: SelectableInput[];

    if (isSelectedPend) {
      selectedOption = pendCode.map(item => new SelectableInput({
        text: item.displayName,
        value: item.pendTypeId,
      }));
    } else {
      const selectedPendCode = this.pendCodeManagerForm.get(key).value;
      if (selectedPendCode) {
        selectedOption = selectedPendCode.map(item => new SelectableInput({
          text: item.text,
          value: item.value,
        }));
      }
    }
    if (ArrayHelper.isAvailable(selectedOption) && isSelectedPend) {
      this.pendCodeManagerForm.get(key).setValue(selectedOption);
    } else {
      if (ArrayHelper.isAvailable(selectedOption)) {
        this.pendCodeManagerForm.get(key).setValue(selectedOption);
      }
    }

    return selectedOption;
  }

  onChange(event: any): void {
    this.pendCodeTypeId = 0;
    if (NumberHelper.isAvailable(event)) {
      this.pendCodeTypeId = event;
      this.isEditPendCode = true;
      this.isPendModalVisible = true;
    }
  }

  onFileSelect(event: any): void {
    this.selectedFile = [];
    for (const file of event.files) {
      const fileExtension = file.name.substr(file.name.lastIndexOf(".") + 1).trim().toLowerCase();
      if (fileExtension === "png") {
        const image = new Image();
        image.src = file.objectURL.changingThisBreaksApplicationSecurity;
        this.uploadedImageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(image.src);
        this.selectedFile.push(file);
        this.formData.append("companyLogo", file);
        this.changeDetector.detectChanges();
        const obj = {
          name: file.name,
          type: file.type,
          fileType: file.type,
          organizationId: this.authService.user.organizationId,
        };
        this.service.getPresignedURL(obj).subscribe(result => {
          this.presignedUrlForLogo = result.presignedURL;
          this.logoFile = file;
          this.normalizedFileName = result.normalizedFileName;
        });
      }
    }
  }

  onFileDelete(fileName: string): void {
    this.logoService.deleteServiceOrgLogo(fileName).subscribe(result => {
      if (result) {
        this.messagingService.showToast("Logo removed successfully", SeverityType.SUCCESS);
        this.logoService.getServiceOrgLogoUrl().subscribe(response => {
          this.changeDetector.detectChanges();
          this.logo = response.organizationLogo;
          this.uploadedFileName = response.fileName;
          this.logoDataSharingService.setLogoUrl(response);
          this.changeDetector.detectChanges();
        });
      }
    });
  }

  onFileRemove(): void {
    this.selectedFile = [];
    this.uploadedImageUrl = null;
  }

  get fileUploaded(): boolean {
    return ArrayHelper.isAvailable(this.selectedFile);
  }

  getServiceOrgLogoUrl(): void {
    this.logoService
      .getServiceOrgLogoUrl()
      .subscribe((response: ServiceOrgLogoResponseModel) => {
        if (response.organizationLogo && StringHelper.isAvailable(response.fileName)) {
          this.uploadedFileName = response.fileName;
          this.logo = this.domSanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${response.organizationLogo}`);
          response.organizationLogo = this.logo;
        }
        this.resetUpload();
        this.logoDataSharingService.setLogoUrl(response);
        this.changeDetector.detectChanges();
      });
  }

  get fileName(): string {
    return (StringHelper.isAvailable(this.uploadedFileName) || ArrayHelper.isAvailable(this.selectedFile)) ?
      (ArrayHelper.isAvailable(this.selectedFile) ? this.selectedFile[0].name : this.uploadedFileName) : "Click to Browse";
  }

  get hasLogo(): boolean {
    if (this.uploadedImageUrl || this.logo) {
      return true;
    }
    return false;
  }

  get fileUploadLabel(): string {
    const labelClass = "file-upload-container__label";
    return ArrayHelper.isAvailable(this.selectedFile) || StringHelper.isAvailable(this.uploadedFileName) ? `${labelClass} file` : `${labelClass} choose`;
  }

  get logoUrl(): SafeResourceUrl {
    return ArrayHelper.isAvailable(this.selectedFile) ? this.uploadedImageUrl : this.logo;
  }

  get logoTooltip(): string {
    return "If you would like your logo to display in the Reveleer App, click browse to upload. File Format must be .png";
  }

  get isServiceOrgLogoAvailable(): boolean {
    return this.logo && !this.uploadedImageUrl;
  }

  resetUpload(): void {
    this.selectedFile = [];
    this.uploadedImageUrl = null;
    this.fileUpload?.clear();
  }

  get providerAgingDescription(): string {
    return "Reduce the number of calls to a Provider by enabling weekly statements. These statements let your providers know at a glance how many chases are outstanding. We also supply a quick link to their secure Medical Record Upload Portal. Statements go out to addresses with the retrieval type set to PSR that have been validated and already have been sent a request for records. Statements will be sent to the provider’s preferred contact method. If there is not a preferred contact method specified they will be sent via email if available. If an email is not available, statements will be sent via fax. Statements will not be sent via mail.  We exclude addresses with special handling enabled from weekly statements.";
  }

  get automatedOutreachDescription(): string {
    return "Reduce the number of calls to a Provider by enabling automatic outreach. When new chases are added the system will automatically begin outreach to addresses with the retrieval type set to PSR that have been validated based on their preferred contact method. If there is not a preferred contact method specified outreach will be sent via email if available. If an email is not available, outreach will be sent via fax. Automatic outreach will not be sent via mail. We also exclude addresses with special handling enabled from automatic outreach.";
  }

  showProviderAgingSample(): void {
    this.isProviderAgingSampleModelVisible = true;
  }

  closeSamplePreview(): void {
    this.isProviderAgingSampleModelVisible = false;
  }

  getProviderAgingSampleImageUrl(): void {
    this.service.getProviderAgingSampleImageUrl()
      .subscribe(response => {
        this.providerAgingSampleImageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${response}`);
      });

    this.changeDetector.detectChanges();
  }

  @HostListener("document:click")
  onClick(): void {
    const fileContent = this.fileUpload?.content?.nativeElement.getElementsByClassName("p-message-close") as HTMLCollectionOf<HTMLAnchorElement>;
    if (fileContent?.length > 0) {
      fileContent[0].click();
    }
  }

  isPendCodeLocked(pendCode: string): boolean {
    this.lockedPendCodesList = ["PC102", "PC103", "PC104", "PC108", "PC109", "PC110", "PC111", "PC115", "PC116", "PC117", "PC120", "PC121", "PC123", "PC124", "PC125", "PC127", "PC128", "PC129", "PC131", "PC300", "PC301", "PC302", "PC303", "PC304", "PC305", "PC506", "PC901", "PC900", "PC1005", "PC1006", "PC139", "PC314", "PC143", "PC1031"];
    return this.lockedPendCodesList.filter(x => x === pendCode).length > 0;
  }

  getDocumentRouting() {
    this.service.getDocumentRoutingByAttribute(DOCUMENT_ROUTING.attributeId)
      .subscribe(data => {
        if (ArrayHelper.isAvailable(data)) {
          this.documentRoutingForm.patchValue({
            BulkUpload: Number(data.find(x => x.retrievalTypeId === DocumentUploadRequestRetrievalType.BulkUpload).routeToBot) === 1,
            Fax: Number(data.find(x => x.retrievalTypeId === DocumentUploadRequestRetrievalType.Fax).routeToBot) === 1,
            FTP: Number(data.find(x => x.retrievalTypeId === DocumentUploadRequestRetrievalType.FTP).routeToBot) === 1,
            Mail: Number(data.find(x => x.retrievalTypeId === DocumentUploadRequestRetrievalType.Mail).routeToBot) === 1,
            Intake: Number(data.find(x => x.retrievalTypeId === DocumentUploadRequestRetrievalType.Intake).routeToBot) === 1,
            ProviderEmail: Number(data.find(x => x.retrievalTypeId === DocumentUploadRequestRetrievalType.ProviderEmail).routeToBot) === 1,
          });
        }
      });
  }

  updateDocumentRouting(event, type) {
    this.documentRoutingDescription = event.checked ? `You are about to enable the chart routing automation for ${type}. Documents received this way will now be routed by the automation. Do you wish to continue?`
      : `You are about to disable the chart routing automation for ${type}. Documents received this way will not be routed by the automation. Do you wish to continue?`;

    this.isSelectedDocumentRoutingChecked = event.checked;
    this.selectedDocumentRouting = type;
    this.showDocumentRoutingPopup = true;
  }

  confirmDocumentRouting() {
    const documentRoutingDataToSend = Object.keys(this.documentRoutingForm.value).reduce((acc, key) => {
      acc.push({
        retrievalTypeId: DocumentUploadRequestRetrievalType[key],
        routeToBot: this.documentRoutingForm.value[key] ? "1" : "0",
      });
      return acc;
    },                                                                                   []);

    this.service.saveServiceOrgConfigurationDocumentRoutingAttribute(documentRoutingDataToSend)
      .subscribe(() => {
        this.getDocumentRouting();
        this.changeDetector.markForCheck();
      });
    this.showDocumentRoutingPopup = false;
  }

  cancelDocumentRouting() {
    this.documentRoutingForm.controls[this.selectedDocumentRouting].setValue(!this.isSelectedDocumentRoutingChecked);
    this.changeDetector.markForCheck();
  }

  enableSso(event: any): void {
    this.isSsoEnabled = event.checked;
    if (this.isSsoEnabled) {
      this.ssoInputsForm.patchValue({
        ssoOption: "legacy",
      });
    } else {
      this.isLegacySSOSelected = event.checked;
      this.saveEnableSSO();
      this.ssoInputsForm.get("ssoOption")?.setValue(null, { emitEvent: false });
      this.saveAuth0Configuration();
    }
  }

  onSSOOptionChange(event: any): void {
    this.isLegacySSOSelected = event === "legacy";
  }

  getDefaultSsoValues() {
    const options = [new SelectableInput({ text: "Microsoft Azure AD", value: "Microsoft Azure AD" })];
    this.indentityProviderInput = new Dropdown({ ...this.indentityProviderInput, options } as any);
    this.changeDetector.markForCheck();
  }

  getEnableSso(): void {
    this.service.getServiceOrgConfigurationByAttribute(ENABLED_SSO.attributeId)
      .subscribe(data => {
        this.isLegacySSOSelected = data.attributeValue === "1";
        this.isSsoEnabled = data.attributeValue === "1";
        this.updateSsoForm();
        this.changeDetector.markForCheck();
      });
  }

  getAuth0Enabled(): void {
    this.service.getServiceOrgConfigurationByAttribute(AUTH0ENABLED.attributeId)
      .subscribe(data => {
        this.isAuth0Enabled = data.attributeValue === "1";
        this.updateSsoForm();
        this.changeDetector.markForCheck();
      });
  }

  getSsoConfiguration() {
    this.getDefaultSsoValues();
    this.service.getSsoConfigurationByAttribute(SSO_CONFIGURATION.attributeId)
      .subscribe(data => {
        if (data !== undefined) {
          this.ssoConfigForm.patchValue({
            indentityProviderInput: data[0].identityProvider,
            applicationIdInput: data[0].applicationId,
            directoryIdInput: data[0].directoryId,
          });

          if (StringHelper.isAvailable(data[0].ssoDomain)) {
            this.ssoDomainForm = this.fb.group({
              Domain: this.fb.array([]),
            });
            const domains = data[0].ssoDomain.split(",");
            domains.forEach(element => {
              (this.ssoDomainForm.get("Domain") as FormArray).push(
                new FormGroup({
                  Domains: new FormControl(element),
                })
              );
            });
          }
        }
      });
  }

  saveEnableSSO(showNotification?: boolean): void {
    this.service.saveServiceOrgEnableSsoAttribute(this.isLegacySSOSelected ? 1 : 0)
      .subscribe(() => {
        if (showNotification) {
          this.messagingService.showToast(`SSO ${this.isLegacySSOSelected ? `Enabled` : `Disabled`}`, SeverityType.SUCCESS);
        }
        this.getSsoConfiguration();
        this.changeDetector.markForCheck();
      });
  }

  saveSSOSettings(): void {
    if (this.isLegacySSOSelected) {
      this.saveSSOConfiguration();
    }
    this.saveEnableSSO();
    this.saveAuth0Configuration(true);
  }

  saveAuth0Configuration(showNotification?: boolean): void {
    const ssoOption = this.ssoInputsForm.get("ssoOption")?.value;
    const isAuth0Enabled = ssoOption === "auth0";
    this.service.saveServiceOrgAuth0EnabledAttribute(isAuth0Enabled ? 1 : 0, isAuth0Enabled && this.isFederated)
      .subscribe(() => {
        this.isAuth0Enabled = isAuth0Enabled;
        if (showNotification) {
          this.messagingService.showToast(`Auth0 ${isAuth0Enabled ? `Enabled` : `Disabled`}`, SeverityType.SUCCESS);
        }
        this.changeDetector.markForCheck();
      });
  }

  saveSSOConfiguration() {
    let domains = "";
    this.ssoDomainForm.get("Domain")?.value.forEach(el => {
      if (StringHelper.isAvailable(el.Domains)) {
        domains += `${el.Domains},`;
      }
    });

    if (this.ssoConfigForm.valid) {
      const params: SsoConfiguration[] = [{
        identityProvider: this.ssoConfigForm.controls[this.indentityProviderInput.key].value,
        applicationId: this.ssoConfigForm.controls[this.applicationIdInput.key].value,
        directoryId: this.ssoConfigForm.controls[this.directoryIdInput.key].value,
        ssoDomain: domains.substring(0, domains.length - 1),
      }];

      this.service.saveServiceOrgConfigurationSsoConfigurationAttribute(params)
        .subscribe(() => {
          this.messagingService.showToast("SSO Configuration saved successfully", SeverityType.SUCCESS);
          this.getSsoConfiguration();
          this.changeDetector.markForCheck();
        });
    } else {
      this.validateForm();
    }
  }

  validateForm(): void {
    this.formService.markAllAsTouched(this.ssoConfigForm);
    this.changeDetector.markForCheck();
  }

  buildDynamicListOfDomains(key) {
    const formGroup = new FormGroup({
      Domains: new FormControl(key),
    });
    return formGroup;
  }

  isRemoveIconVisible(forms: FormGroup[], index: number): boolean {
    return forms.length !== index + 1;
  }
  confirmCallerId(callerIdNumber: any, flag: boolean): Promise<void> {
    return new Promise((resolve, reject) => {
      this.service.RegisterCallerIdNumber(callerIdNumber).subscribe(
        response => {
          this.CallerIdVVerificationCode = response;
          this.callerIdVerificationStatus = response === UserMessages.phoneNumberVerified;

          // Handle success or failure
          if (this.callerIdVerificationStatus) {
            this.changeDetector.detectChanges();
            this.callerIdValidationControl.disabled = this.callerIdVerificationStatus;
          }
          if (this.callerIdVerificationStatus && flag) {
            this.messagingService.showMessage(UserMessages.callerIdVerified, SeverityType.SUCCESS);
          } else if (!this.callerIdVerificationStatus && flag) {
            const severity = this.CallerIdVVerificationCode.includes("valid") ? SeverityType.ERROR : SeverityType.SUCCESS;
            const message = this.CallerIdVVerificationCode.includes("valid") ? this.CallerIdVVerificationCode : UserMessages.twilioVerificationCodeMessage + this.CallerIdVVerificationCode;
            this.messagingService.showMessage(message, severity);
          }

          resolve();  // Resolve after handling response
        },
        error => {
          reject(error);  // Reject if there's an error
        }
      );
    });
  }
  onValidateButtonClick(value: any): void {
    if (value === "") {
      this.messagingService.showMessage(UserMessages.blankPhoneNumber, SeverityType.ERROR);
      return;
    }
    this.confirmCallerId(value, true);
  }
}
